<!--模板-->
<template>
  <div id="home">
    <!--顶部图片-->
    <div class="home_img">
      <img src="../../../static/images/home/homebar.jpg" />
    </div>
    <div class="home_content clear">
      <!--侧边栏-->
      <div class="home_left">
        <div class="title_name" @click="$router.push('/homePage?nameCode=' + getUser.user._id)">
          <img v-if="getUser" :src="getUser.user.avatar" />
          <p style="padding:5px 0;font-size:18px;">我的主页</p>
        </div>
        <router-link to="" tag="li" style="background: #f5f5f5!important;"></router-link>
        <router-link to="/home/personal" tag="li">个人概览</router-link>
        <router-link to="/home/authInfor" tag="li">基本资料</router-link>
        <router-link to="/home/photoPage" tag="li">我的相册</router-link>
        <!-- <router-link to="/home/assets" tag="li">资金资产</router-link> -->
        <router-link to="/home/accountsecurity" tag="li">账户安全</router-link>
        <!-- <router-link to="/home/order" tag="li">购买订单</router-link> -->
        <router-link to="" tag="li" style="background: #f5f5f5!important;"></router-link>

        <!-- <router-link to="/home/endorsementAdd" tag="li">发布心愿</router-link> -->
        <!-- <router-link to="/home/endorsement" tag="li">心愿单</router-link> -->

        <!--<router-link to="/home/dynamics" tag="li">我的动态</router-link> -->

        <router-link to="" tag="li" style="background: #f5f5f5!important;"></router-link>
        <router-link to="/home/authenticate" tag="li" v-if="UserProof && UserProof.checkStatus != 2">
          <span v-if="UserProof.checkStatus == 0">申请认证服务者</span>
          <span v-if="UserProof.checkStatus == 1">认证服务者 (审核中)</span>
          <span v-if="UserProof.checkStatus == 3">认证服务者 (未通过)</span>
        </router-link>
        <router-link to="/home/services/service" v-if="UserProof && UserProof.checkStatus != 0 && UserProof.checkStatus != 3" tag="li">发布技能服务</router-link>
        <!-- <router-link to="/home/servicesList" tag="li" >技能服务</router-link> -->
        <!-- <router-link to="/home/accompaniedorders" tag="li" >服务订单</router-link> -->
      </div>
      <!--右侧内容切换-->
      <div class="home_right">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<!--JS-->
<script>
import http from 'api/api'
import photoPage from './photoPage'

import $ from "jquery";
export default {
  components: {
    photoPage
  },
  data () {
    return {
      orderType: 0,
      getUser: '',
      UserProof: ''
    }
  },
  methods: {
    jump () {//发布服务
      this.$router.push({ name: 'service' })
    },
    // 侧边栏切换
    barShow (index) {
      this.bar_show = index
      if (index == 3) {
        this.getMoneyFund()
      }
      if (index == 6) {
        this.showPhoto = true
      }
    },
    changeOrderState (num) {
      this.orderType = num
    },

  },
  mounted () {
    // 获取个人信息
    http.GET('/jw-function', {
      module: 'home',
      operation: 'getUserHome',
      uid: localStorage.getItem('pbw_user_pc_uid'),
    }).then((res) => {
      this.getUser = res
    })

    // 认证信息

  }
};
</script>

<style>
.home_left li {
  cursor: pointer;
}
.el-tabs--border-card {
  border: 0px !important;
  -webkit-box-shadow: 0 !important;
  box-shadow: 0 !important;
  -webkit-box-shadow: 0 0px 0px 0 transparent !important;
  box-shadow: 0 0px 0px 0 transparent !important;
}
.el-tabs--border-card > .el-tabs__header {
  border: 1px solid #e4e7ed !important;
}
.el-tabs--border-card > .el-tabs__content {
  padding: 20px 4px !important;
}
</style>

<!--css样式-->
<style lang="scss" scoped>
@import '../../../src/scss/commonH5.scss';
@import '../../scss/demo.scss';

/* 基本资料 */
.avatar {
  height: 120px;
  border-radius: 90px;
  border: 1px solid #d6d6d6;
}
.personal-money-tip {
  font-size: 24px;
}
.personal-money {
  font-size: 56px;
  font-weight: bold;
}
.personal-money-btn {
  color: #fff !important;
  background: #698adb;
  padding: 16px 50px;
  border-radius: 10px;
  font-size: 18px;
}
.personal-money-btm-tip {
  color: #999 !important;
  float: right;
  margin-top: -20px;
  margin-right: 30px;
}
.personal-money-one {
  color: #fff !important;
  background: #698adb;
  padding: 6px 30px;
  border-radius: 10px;
  font-size: 16px;
  margin-top: 24px;
}
.personal-money-two {
  color: #fff !important;
  background: #26b3f4;
  padding: 6px 30px;
  border-radius: 10px;
  font-size: 16px;
  margin-top: 24px;
  margin-right: 20px;
}
.personal-money-tip {
  font-size: 24px;
}

.repeatable .el-col-24 .el-button {
  background-color: #f46101;
  color: white;
  width: 250px;
  border: 0;
  font-size: 18px;
}

.home_img,
.home_img img {
  width: 100%;
}
.title_name {
  border-radius: 30px 30px 0 0;
  text-align: center;
  padding: 20px 0px;
  border-bottom: 1px solid #dcddde;
}
.title_name img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.title_left i {
  padding-right: 10px;
  margin-left: 35px;
}
.bar {
  background: #f16202 !important;
  color: #fff !important;
}
.home_left li {
  background: #fff;
  border-bottom: 1px solid #dcddde;
  text-align: center;
  padding: 18px;
  margin: 0 auto;
  font-size: 18px;
}
.router-link-exact-active,
.router-link-active {
  color: #fff;
  background: #f60 !important;
}
.home_content {
  width: 1200px;
  margin: 50px auto;
}
.home_left {
  border-radius: 30px 30px 0 0;
  float: left;
  width: 26%;
  background: #fff;
  border: 1px solid #dcddde;
}
.home_right {
  width: 66%;
  float: right;
  background: #fff;
  border: 1px solid #dcddde;
  padding: 20px;
}
.colorBule {
  color: #26b3f4;
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue